module.exports = __webpack_public_path__ + "files/44c03669296b7dcb79e52b36d3d405ef.png";